




import { Vue, Component } from 'vue-property-decorator';

import YourAccountComplete from './default-user-signup/YourAccountComplete.vue';
import { OnboardingURL } from '@/views/Onboarding/helpers';

@Component({
  components: { YourAccountComplete }
})
export default class DirectYourAccountComplete extends Vue {
  get backUrl() {
    return OnboardingURL.USER_SIGN_UP;
  }

  onNext() {
    this.$store.dispatch('businessOnboarding/SET_CREATED_ACCOUNT', true);
    setTimeout(() => {
      this.$router.push(OnboardingURL.WELCOME_TWISM);
    }, 1200);
  }
}
